import React from 'react'
import { Modal, notification, Icon, Badge } from 'antd'
import { transform, isEqual, isObject, find } from 'lodash'
import { gtagOKEvent } from './gtag'
import moment from 'moment'

notification.config({
  placement: 'topRight',
  top: 80,
  duration: 2,
})

const {
  RECAPTCHA_CLIENT_KEY: RECAPTCHA_KEY,
  REACT_APP_RECAPTCHA_SCRIPT_URL: RECAPTCHA_SCRIPT_URL = "https://www.google.com/recaptcha/enterprise.js"
} = process.env;

export function parseJSON(response) {
  return response.data
}

export function validDateField(fileDate) {
  const dateFile = moment(fileDate)
  const isAfter = dateFile.isAfter(moment(), 'day')
  const isBefore = dateFile.isBefore(moment().subtract(5, 'days'), 'day')
  let error = null

  if (isAfter) {
    error = 'La Fecha de emisión debe corresponder a una fecha igual o anterior a hoy'
  } else if (isBefore) {
    error = 'Por favor ingrese una fecha de emisión que corresponda a no más de 5 días antes de hoy'
  } else if (fileDate === '') {
    error = 'Debe ingresar una fecha y certificado de vigencia laboral'
  }

  return error
}

export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type]

    return reducer ? reducer(state, action.payload) : state
  }
}

export function debounce(func, wait, immediate) {
  let timeout

  return function() {
    const context = this
    const args = arguments
    const callNow = immediate && !timeout

    clearTimeout(timeout)

    timeout = setTimeout(function() {
      timeout = null
      if (!immediate) func.apply(context, args)
    }, wait)
    if (callNow) func.apply(context, args)
  }
}

export function formatterAmountSlider(value) {
  return `${value}%`
}

export function formatterCuotasSlider(value) {
  return `${value} Cuotas`
}

export function formatterAmount(value, stringReplace = '.') {
  return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, `${stringReplace}`)
}

export function formatterAmountFix(value) {
  let amount = `${value}`.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, `.`)
  return amount
}

export function formatPhone(phone) {
  if (phone.length >= 8) {
    return phone.slice(phone.length - 8, phone.length)
  }
  return phone
}

export function translateFilter(value) {
  const obj = {
    nuevo: 'Nuevo',
    doc_aprobados: 'Documentos aprobados',
    rechazada: 'Solicitud rechazada',
    true: 'Firmado',
    false: 'Firma pendiente',
  }
  return obj[value] ? obj[value] : value
}

export function warningModal() {
  Modal.error({
    title: 'No se puede cursar su solicitud de Crédito',
    content: 'Para obtener más información contáctenos al 600 510 00 00.',
    okText: 'Aceptar',
    onCancel() {},
    onOk(e) {
      e(true)
    },
  })
}

export function notElegibleModal() {
  Modal.warning({
    title: 'Crédito Pre aprobado',
    content: (
      <span className="eligible-modal">
        Para gestionar tu solicitud de Crédito Social o aclarar dudas, puedes hacerlo en línea a
        través de Whatsapp.&nbsp;
        <a
          href="https://api.whatsapp.com/send?phone=56936573560&text=%C2%A1Hola%20Caja%20Los%20Andes!#"
          onClick={() => {
            gtagOKEvent('Contacto Soporte Whatsapp', 'Filtro Paso 1')
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Ingresa aquí
        </a>
      </span>
    ),
    okText: 'Cerrar',
    onCancel() {},
    onOk(e) {
      e(true)
    },
  })
}

export function onSignFilesSuccessModal () {
  Modal.success({
    title: 'Firma de documentos exitosa',
    content: <div className='sign-success-modal'>
      Has firmado correctamente tus documentos. Te enviaremos la copia de estos a tu correo electrónico y te informaremos cuando se haga efectivo el depósito en tu cuenta. <b>El depósito de tu crédito se realizará dentro de 24 horas hábiles.</b>
    </div>
  })
}

export function onlyDeliveryInRMModal() {
  Modal.warning({
    title: 'Crédito Pre aprobado',
    content: (
      <span className="eligible-modal">
        Para gestionar tu solicitud de Crédito Social para el área de cobertura seleccionada, puedes
        hacerlo en línea a través de Whatsapp.&nbsp;
        <a
          href="https://api.whatsapp.com/send?phone=56936573560&text=%C2%A1Hola%20Caja%20Los%20Andes!#"
          onClick={() => {
            gtagOKEvent('Contacto Soporte Whatsapp', 'Filtro Paso 2')
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Ingresa aquí
        </a>
      </span>
    ),
    okText: 'Cerrar',
    onCancel() {},
    onOk(e) {
      e(true)
    },
  })
}

export function serviceNotAvailableModal(message) {
  Modal.error({
    title: 'El servicio no se encuentra disponible',
    content: message,
    okText: 'Aceptar',
    onCancel() {},
    onOk(e) {
      e(true)
    },
  })
}

export function openNotification(fileName, message, icon) {
  const color = icon === 'check-circle' ? '#52c41a' : '#eb2f96'
  const args = {
    message: `Documento ${fileName}`,
    description: `${message}`,
    duration: 3,
    icon: <Icon type={icon} theme="twoTone" twoToneColor={color} />,
  }
  notification.open(args)
}

export const openNotificationWithIcon = (type, title, message) => {
  notification[type]({
    message: title,
    description: message,
  })
}

export function parseSolicitudesCreditos(solicitudes) {
  const parseSolicitudes = solicitudes.map((solicitud, index) => {
    let usuarioAsignado = null
    if (solicitud.cclaUserId === null && solicitud.solicitudCreditoHistory.length > 0) {
      usuarioAsignado = solicitud.solicitudCreditoHistory[0].cclaUser.username
    } else if (solicitud.cclaUserId !== null) {
      usuarioAsignado = solicitud.cclaUser.username
    }
    return {
      key: index,
      solicitudId: solicitud.id,
      folio: solicitud.folio,
      fechaEnvio: moment(solicitud.createdAt).format('DD/MM/YYYY HH:mm'),
      fechaActualizacion: moment(solicitud.updatedAt).format('DD/MM/YYYY HH:mm'),
      estadoSolicitud: solicitud.status,
      estadoCCR: false,
      channel: solicitud.simulacion.oferta.channel,
      ofertaId: solicitud.idOfertaEconomica || '',
      usuarioAsignado: usuarioAsignado,
      userId: solicitud.cclaUserId,
      userRut: solicitud.simulacion.oferta.user.rut,
    }
  })
  return parseSolicitudes
}

export function parseSolicitudesHistory(solicitudes) {
  const parsedSolicitudes = solicitudes.map((solicitud, index) => {
    return {
      key: index,
      solicitudId: solicitud.id,
      folio: solicitud.folio,
      fechaEnvio: moment(solicitud.createdAt).format('DD/MM/YYYY HH:mm'),
      estadoSucursalVirtual: solicitud.statusSucursalVirtual,
      motivoRechazoSolicitud: solicitud.motivoRechazoSolicitudCredito
        ? solicitud.motivoRechazoSolicitudCredito.name
        : '',
      files: solicitud.simulacion.oferta.files,
    }
  })
  return parsedSolicitudes
}

export function parseSolicitudCredito (solicitud) {
  const user = solicitud[0].simulacion.oferta.user
  const simulacion = solicitud[0].simulacion
  const files = solicitud[0].simulacion.oferta.files.map(file => {
    const response={
      fileId: file.id,
      nombre: file.name,
      path: `${file.fileUrl}`,
      estadoDocumento: file.status,
      motivoRechazoFileId: file.motivoRechazoFileId ? file.motivoRechazoFileId : undefined,
      tipo: file.type
    }
    return response
  })

  return {
    datosAfiliado: {
      rut: user.rut,
      nombre: formatFullName(user.firstName, user.lastName1, user.lastName2),
      banco: ( user.bankAccount !== null ) ? user.bankAccount.bank.name : '',
      tipoCuenta: ( user.bankAccount !== null) ? user.bankAccount.type : '',
      numeroCuenta: ( user.bankAccount !== null) ? user.bankAccount.number : '',
      tipoAfiliado: user.tipoAfiliado,
      numeroSerie: user.serialNumber
    },
    datosCredito: {
      montoSolicitado: simulacion.montoSolicitado,
      numeroCuotas: simulacion.cuotas,
      segCesantia: simulacion.seguroCesantia > 0,
      tipoTrabajador: simulacion.tipoTrabajador,
      beneficioSocial: simulacion.beneficioSocial
    },
    documentos: files,
    solicitudCreditoId: solicitud[0].id,
    idOferta: solicitud[0].idOfertaEconomica,
    canal: solicitud[0].simulacion.oferta.channel,
    folio: solicitud[0].folio,
    motivoRechazoSolicitudCreditoId: solicitud[0].motivoRechazoSolicitudCreditoId
      ? solicitud[0].motivoRechazoSolicitudCreditoId
      : undefined,
    fechaEnvio: moment(solicitud[0].createdAt).format('L'),
    estadoSolicitud: solicitud[0].status,
    estadoCCR: solicitud[0].statusCCR,
    error: null,
    fetchingSolicitud: false
  }
}

export function closedSolicitudesStatusNames() {
  return [
    'DESEMBOLSADO',
    'SOLICITUD RECHAZADA',
    'PENDIENTE DE DESEMBOLSO',
    'OTRO MEDIO DE DESEMBOLSO',
    'CREDITO ACTIVO',
  ]
}

export function inProgressSolicitudesStatusNames() {
  return [
    'DOCUMENTOS APROBADOS',
    'SOLICITUD INGRESADA',
    'SOLICITUD INGRESADA CON CCR PENDIENTE',
    'GENERAR DOCUMENTOS',
    'CCR EN GESTION',
    'DOCUMENTOS DISPONIBLES PARA FIRMAR',
    'DOCUMENTOS FIRMADOS',
    'CREDITO ACTIVO',
  ]
}

export function renderBadgeSolicitud(estadoSolicitud) {
  let options = {}
  const aproved = ['NUEVO', 'DESEMBOLSADO']
  const pending = [
    'DOCUMENTOS APROBADOS',
    'SOLICITUD INGRESADA',
    'SOLICITUD INGRESADA CON CCR PENDIENTE',
    'CCR EN GESTION',
    'DOCUMENTOS DISPONIBLES PARA FIRMAR',
    'DOCUMENTOS FIRMADOS',
    'GENERAR DOCUMENTOS',
    'CREDITO ACTIVO',
    'PENDIENTE DE DESEMBOLSO',
    'OTRO MEDIO DE DESEMBOLSO',
  ]

  if (aproved.includes(estadoSolicitud)) {
    options = { status: 'success', text: estadoSolicitud }
  } else if (pending.includes(estadoSolicitud)) {
    options = { status: 'warning', text: estadoSolicitud }
  } else {
    options = { status: 'error', text: estadoSolicitud }
  }
  return <Badge {...options} />
}

export function renderBadgeSucursalVirtual(estadoSolicitud) {
  let options = {}
  const aproved = ['SOLICITUD ENVIADA', 'CREDITO OTORGADO', 'CREDITO APROBADO']
  const pending = [
    'SOLICITUD EN PROCESO',
    'DOCUMENTOS DISPONIBLES PARA FIRMAR',
    'EN PROCESO DE DESEMBOLSO',
  ]

  if (aproved.includes(estadoSolicitud)) {
    options = { status: 'success', text: estadoSolicitud }
  } else if (pending.includes(estadoSolicitud)) {
    options = { status: 'warning', text: estadoSolicitud }
  } else {
    options = { status: 'error', text: estadoSolicitud }
  }
  return <Badge {...options} />
}

export function renderBadgeUserCCR(estadoCCR) {
  let options = {}
  const f = ['FIRMADO']
  const pg = ['PENDIENTE', 'EN GESTION']

  if (f.includes(estadoCCR)) {
    options = { status: 'success', text: estadoCCR }
  } else if (pg.includes(estadoCCR)) {
    options = { status: 'warning', text: estadoCCR }
  } else if (estadoCCR === null) {
    options = { status: 'success', text: 'FIRMADO' }
  } else {
    return ''
  }
  return <Badge {...options} />
}

export function renderBadgeCCR(estadoCCR) {
  const statusCCR = estadoCCR === 'PENDIENTE' ? 'warning' : 'success'
  return <Badge status={statusCCR} text={estadoCCR} />
}

export function getTypeDocument(typeDocument) {
  const obj = {
    CVL: 'Certificado de vigencia laboral',
    'CI-ANVERSO': 'Cédula de Identidad (frontal)',
    'CI-REVERSO': 'Cédula de Identidad (reverso)',
    'DJDIG': 'Declaración Jurada'
  }
  return obj[typeDocument] ? obj[typeDocument] : obj['CVL']
}

export function comparerFiles(otherArray) {
  return current => {
    return (
      otherArray.filter(other => {
        const valid = other.statusFile === current.statusFile && other.motivoId === current.motivoId
        return valid
      }).length === 0
    )
  }
}

export function openCVLInfo() {
  Modal.info({
    title: '¿Cómo conseguir el Certificado de Vigencia Laboral?',
    okText: 'Cerrar',
    content: (
      <div className="cvl-modal">
        <div>
          El Certificado de Vigencia Laboral es un documento que entrega tu empleador firmado y
          timbrado por la empresa, con vencimiento menor a 5 días desde la fecha de emisión. En el
          caso de contrato a plazo fijo, por obra o faena, el certificado de vigencia debe contar
          con fecha de término de servicios o término estimado de obra. También se aceptarán los
          certificados emitidos por sistemas de autoservicio dispuestos por las empresas.
        </div>
        <div>
          <br></br>
          <b>
            <Icon type="search" /> Revisa en tu Certificado:
          </b>
          <ol>
            <li>Que aparezcan el nombre y rut de tu empresa.</li>
            <li>Que tu rut y nombre estén correctos.</li>
            <li>Que el documento sea legible.</li>
            <li>Que la fecha de emisión del documento sea hace menos de 5 días.</li>
            <li>Que aparezca el timbre y la firma de la empresa.</li>
          </ol>
        </div>
      </div>
    ),
    onOk() {},
  })
}

export function openCIInfo() {
  Modal.info({
    title: '¿Cómo cargar la Cédula de Identidad?',
    okText: 'Cerrar',
    content: (
      <div className="cvl-modal">
        <div>
          Se debe cargar una foto o escaneo de la Cédula de Identidad por ambos lados.
        </div>
        <div>
          <br></br>
          <b>
            <Icon type="search" /> Revisa en tu Cédula de Identidad:
          </b>
          <ol>
            <li>Que la foto sea clara y legible.</li>
            <li>Que la cédula se encuentre vigente al día de la solicitud.</li>
          </ol>
        </div>
      </div>
    ),
    onOk() {},
  })
}

export function openDeclaracionInfo(){
  Modal.info({
    title: '¿Cómo conseguir el certificado de Vigencia Laboral?',
    okText: 'Cerrar',
    className:'modal-custom',
    width: '45%',
    content: (
      <div className="cvl-modal">
        <p className='modal-cuerpo-letra'>
          El certificado de Vigencia Laboral es un documento que entrega tu
          empleador firmado y timbrado por la empresa con vencimiento menor a 5
          días desde la fecha de emisión.<br/>
          En el caso de contrato a plazo fijo por obra o faena, el certificado de vigencia
          debe contar con fecha de término de servicios o término estimado de obra.<br/>
          También se aceptarán los certificados emitidos por sistemas de autoservicio
          dispuestos por la empresa.
        </p>
        <br/>
        <div>
          <b className='modal-titulo modal-cuerpo-letra'>
            <Icon type="search" theme="outlined"/> Revisa en tu certificado:
          </b>
          <ol className='modal-cuerpo modal-cuerpo-letra'>
            <li>Que aparezcan el nombre y rut de tu empresa.</li>
            <li>Que rut y nombre estén correctos.</li>
            <li>Que el documento sea legible.</li>
            <li>Que la fecha de emisión del documento sea hace menos de 5 días.</li>
            <li>Que aparezca el timbre y la firma de la empresa.</li>
          </ol>
        </div>
        <br/>
        <div>
          <b className='modal-titulo'>
            <Icon type="info-circle" theme="outlined"/> ¿Qué es una declaración jurada?
          </b>
          <p className='modal-cuerpo modal-cuerpo-letra'>
            Una declaración jurada es un documento escrito que pretende ser la
            declaración voluntaria y verdadera de una persona, que es quien firma el
            documento.
          </p>
        </div>
      </div>
    ),
    onOk() {},
  })
}

export function formatFullName(firstName, lastName1, lastName2) {
  return `${firstName || ''} ${lastName1 || ''} ${lastName2 || ''}`.trim()
}

export function altBackOfficeNavbarName(name) {
  const options = {
    FIRMACCR: 'GESTIÓN CCR',
  }
  return options[name] ? options[name] : name
}

export function objDifference(object, base) {
  return transform(object, (result, value, key) => {
    if (!isEqual(value, base[key]) || (isObject(base[key]) && base[key].id === value)) {
      result[key] = isObject(value) && isObject(base[key]) ? objDifference(value, base[key]) : value
    }
  })
}

export function flattenObject(ob) {
  let toReturn = {}
  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue
    if (typeof ob[i] == 'object' && ob[i] !== null) {
      let flatObject = flattenObject(ob[i])
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue
        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = ob[i]
    }
  }
  return toReturn
}

export function userObjToString(userObj, regions, communes, banks) {
  // Flatten obj
  const flatObj = flattenObject(userObj)
  // Replace ids with names
  if (flatObj['address.commune'] !== null && flatObj['address.commune'] !== undefined) {
    const commune = find(communes, function(c) {
      return c.id === flatObj['address.commune']
    })
    flatObj['address.commune'] = commune.name
  }
  if (flatObj['address.region'] !== null && flatObj['address.region'] !== undefined) {
    const region = find(regions, function(r) {
      return r.id === flatObj['address.region']
    })
    flatObj['address.region'] = region.name
  }
  if (flatObj['bankAccount.bank'] !== null && flatObj['bankAccount.bank'] !== undefined) {
    const bank = find(banks, function(b) {
      return b.id === flatObj['bankAccount.bank']
    })
    flatObj['bankAccount.bank'] = bank.name
  }
  // Return string
  return flatObjToString(flatObj)
}

function flatObjToString(obj) {
  let baseString = ''
  for (let key in obj) {
    baseString += `${key}: ${obj[key]}, `
  }
  return baseString.length > 0 ? baseString.substring(0, baseString.length - 2) : baseString
}

export function userObjFlatString(userObj, oldUserObj, regions, communes, banks) {
  userObj.phone = userObj.phone.replace(/[^a-zA-Z\d\s]/gi, '')
  const userObjDiff = objDifference(userObj, oldUserObj)
  return userObjToString(userObjDiff, regions, communes, banks)
}

export function isPensionado(tipoAfiliado) {
  return ['PEDL', 'PEFA'].includes(tipoAfiliado)
}

export function hideKeyWords(text, quantity) {
  const textString = text.toString()
  const textFiltered = textString.slice(textString.length - quantity)
  return `${'*'.repeat(text.length - textFiltered.length)}${textFiltered}`
}

export function isCuentaRut(bankAccount) {
  const validBank = bankAccount.bank && bankAccount.bank === 14
  const validType = bankAccount.type.length && bankAccount.type.toUpperCase() === 'CUENTA VISTA'

  return validBank && validType
}

export function modalCuentaRut() {
  Modal.error({
    title: 'Estimado Usuario',
    content:
      'Esta solicitando un monto mayor al permitido para el abono mensual de una Cuenta Rut, monto máximo permitido $2.000.000. Para poder seguir con el proceso debe seleccionar una cuenta diferente a una Cuenta Rut. Para obtener más información contáctenos al 600 510 00 00 (Selecciona la opción 1 y luego 1)',
    okText: 'Aceptar',
    onCancel() {},
    onOk(e) {
      e(true)
    },
  })
}

export function normalizeString(value) {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, "")
}

export function replaceAll(value, search, replacement) {
  return value.split(search).join(replacement)
}

export function filterChildren(children, input) {
  return normalizeString(children)
    .indexOf(
      normalizeString(input)
    ) >= 0
}

export function validString(value, invalidCharacters) {
  for (let character of invalidCharacters) {
    if (value.includes(character)) {
      return false
    }
  }
  return true
}

export function validEmailAddress(value) {
  // checks if the given value is a valid email address given a certain set of invalid characters
  const invalidCharacters = ['|', '[', ']', '(', ')', ':', ';', ',', '<', '>', '$', '\'']
  const normalized = normalizeString(value)
  if (normalized !== value.toLowerCase()) {
    return false
  }
  return validString(normalized, invalidCharacters)
}

const loadScript = (url, {isAsync = true, onLoaded}) => {
  const el = document.createElement("script");
  el.async = isAsync;
  el.src = url;

  if (onLoaded && typeof onLoaded === "function") {
    el.onload = onLoaded;
  }

  document.body.appendChild(el);
};

export const loadRecaptchaScript = (onLoaded) => {
  const url = `${RECAPTCHA_SCRIPT_URL}?render=${RECAPTCHA_KEY}`;
  loadScript(url, {onLoaded});
};
